import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class TOASlideShowPage extends SlideShowPage {

    static isIntroScreen: boolean = true;
    private _textField: PIXI.Text;
    private _textOriginalWidth: number = 0;

    constructor(texture?: PIXI.Texture, textString?: string, backgroundColor?: number, imageLeft?: boolean) {
        super(undefined, undefined, undefined, undefined);

        if (texture != undefined) {
            var image = new PIXI.Sprite(texture);
            image.anchor.set(0.5);
            image.position.x = 0;
            this.addChild(image);
        }
        if (textString != undefined) {
            this._textField = new PIXI.Text(textString, TombOfAkhenatenTextStyles.GAME_INTRO_TEXT_FONT);
            this._textField.anchor.set(0.5);
            this._textField.position.x = 0;
            this._textField.position.y = 145;
            this._textOriginalWidth = this._textField.width;
            this.addChild(this._textField);
        }

        NolimitApplication.events.on(NolimitApplication.RESIZE, () => {
            if (TOASlideShowPage.isIntroScreen) {
                let reelAreaWidth: number = TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.85,
                    textWidth: number = this._textOriginalWidth;

                if (textWidth > reelAreaWidth) {
                    this._textField.scale.set(parseFloat((reelAreaWidth / textWidth).toFixed(2)));
                } else {
                    this._textField.scale.set(1);
                }
            }
        });

        if (TombOfAkhenaten.api.gameClientConfiguration.isSet) {
            if (!TombOfAkhenaten.api.gameClientConfiguration.showLowProbabilityGfx) {
                this._textField.visible = false;
            }
        } else {
            TombOfAkhenaten.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (!TombOfAkhenaten.api.gameClientConfiguration.showLowProbabilityGfx) {
                    this._textField.visible = false;
                }
            });
        }

    }
}